import { useState } from "react";
import React from "react";
import "../styles/components/slideshow.css";
import JobRunner from "./jobrunner";
import DomainSetup from "./domain-setup";

const slides = [<DomainSetup key="domain" />, <JobRunner key="jobrunner" />];

export default function ServerCreate() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    if (currentIndex < slides.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const prevSlide = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <div>
      <h2>Opprett ny server:</h2>
      <div className="slideshowContainer">
        <div className="slide">{slides[currentIndex]}</div>
        <div className="controls">
          {currentIndex > 0 && (
            <button onClick={prevSlide} className="slideshow-button">
              Tilbake
            </button>
          )}
          {currentIndex < slides.length - 1 && (
            <button onClick={nextSlide} className="slideshow-button">
              Fullført
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
